import React from "react";
import PropTypes from "prop-types";
import Published from "components/Published";
import FluidImage from "components/FluidImage";
import Image from 'components/Image';
import cn from 'classnames';

import "./ArticleTeaser.scss";

const ArticleTeaser = ({ url, heading, image, published, publishedLabel }) => {
    return (
        <div className="article-teaser">
            <a className="article-teaser__link" href={url}>
                <div className={cn("article-teaser__image-holder", {
                    "article-teaser__image-holder_no-image": !image
                })}>
                    {image ? (
                        <FluidImage
                            className="article-teaser__image"
                            image={image.url}
                            altText={image.altText}
                            visible={true}
                        />
                    ) : 
                        null
                    }
                </div>
                <div className="article-teaser__heading-holder">
                    <h3 className="article-teaser__heading">{heading}</h3>
                </div>
                {published && (
                    <Published label={publishedLabel} date={published} className="article-teaser__published-date" />
                )}
            </a>
        </div>
    );
};

ArticleTeaser.propTypes = {
    image: PropTypes.shape(Image.propTypes),
    published: PropTypes.string,
    url: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    publishedLabel: PropTypes.string,
};

export default ArticleTeaser;


// WEBPACK FOOTER //
// ./src/components/ArticleTeaser/ArticleTeaser.jsx